export default __webpack_public_path__ + "img/234e75c81565514c9e4204077a20e365.svg";